import { render } from "./AppSectionTabs.vue?vue&type=template&id=878e9760&scoped=true"
import script from "./AppSectionTabs.vue?vue&type=script&lang=js"
export * from "./AppSectionTabs.vue?vue&type=script&lang=js"

import "./AppSectionTabs.vue?vue&type=style&index=0&id=878e9760&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-878e9760"]])

export default __exports__